import Message from '@sats-group/ui-lib/react/message';
import Text from '@sats-group/ui-lib/react/text';
import VisuallyHidden from '@sats-group/ui-lib/react/visually-hidden';
import React from 'react';
import ContentBlocks from '~/client/components/content-blocks/content-blocks';
import ContentContainer from '~/client/components/content-container/content-container';
import FrontpageHero from '~/client/components/frontpage-hero/frontpage-hero';
import Hero from '~/client/components/hero/hero';
import { HeroType } from '~/client/components/hero/hero.types';
import Layout from '~/client/components/layout/layout';
import NavigationCard from '~/client/components/navigation-card/navigation-card';
import UpcomingTrainingsList from '~/client/components/upcoming-trainings-list/upcoming-trainings-list';
import UspList from '~/client/components/usp-list/usp-list';
import type { LandingPage as Props } from './landing-page.types';

const Row: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="landing-page__row">{children}</div>
);

const LandingPage: React.FunctionComponent<Props> = ({
  blocks,
  greeting,
  hero,
  layout,
  shortcuts,
  title,
  upcomingClasses,
  uniqueSellingPoints,
}) => (
  <Layout {...layout}>
    <div className="landing-page">
      {hero ? (
        <Row>
          {hero.type === HeroType.Frontpage ? (
            <FrontpageHero {...hero} />
          ) : (
            <Hero {...hero} />
          )}
        </Row>
      ) : (
        <VisuallyHidden>
          <h1>{title}</h1>
        </VisuallyHidden>
      )}

      {uniqueSellingPoints ? (
        <Row>
          <ContentContainer theme={ContentContainer.themes.wide}>
            <UspList {...uniqueSellingPoints} />
          </ContentContainer>
        </Row>
      ) : null}

      {greeting ? (
        <Row>
          <ContentContainer theme={ContentContainer.themes.wide}>
            <Text
              elementName="h2"
              size={Text.sizes.headline3}
              theme={Text.themes.normal}
            >
              {greeting}
            </Text>
          </ContentContainer>
        </Row>
      ) : null}

      {shortcuts.length ? (
        <Row>
          <ContentContainer theme={ContentContainer.themes.wide}>
            <div className="landing-page__shortcuts">
              {shortcuts.map(item => (
                <NavigationCard {...item} key={item.href} tall />
              ))}
            </div>
          </ContentContainer>
        </Row>
      ) : null}

      {upcomingClasses ? (
        <Row>
          <ContentContainer theme={ContentContainer.themes.wide}>
            <div className="landing-page__upcoming-classes">
              <Text
                elementName="h2"
                theme={Text.themes.normal}
                size={Text.sizes.large}
              >
                {upcomingClasses.title}
              </Text>

              {upcomingClasses.messages.map(message => (
                <Message {...message} key={message.text} />
              ))}

              {upcomingClasses.classes.map(entry => (
                <div key={entry.title}>
                  <UpcomingTrainingsList
                    {...entry}
                    titleProps={{
                      elementName: 'h3',
                      size: Text.sizes.large,
                      theme: Text.themes.emphasis,
                    }}
                  />
                </div>
              ))}
            </div>
          </ContentContainer>
        </Row>
      ) : null}

      {blocks ? (
        <Row>
          <ContentContainer theme={ContentContainer.themes.wide}>
            <ContentBlocks {...blocks} />
          </ContentContainer>
        </Row>
      ) : null}
    </div>
  </Layout>
);
export default LandingPage;
